import React, { useState, useEffect, useRef } from 'react'
import { Box } from '@mui/material'
import { LEGEND_COLOR_MAP_V2 } from '../../constants'
import CustomTootTip1 from './customTootTip1'
import { Wrapper, InnerBar, ToolTipWrapper } from './style'

export default function ChartBarHorizontalCustom(props) {
  const [barGraphWidth, setBarGraphWidth] = useState(300)
  const refBarId = useRef(`_bar_${props.data.length}_${new Date().getTime()}`)
  const max = props?.isDecimal
    ? parseFloat(props?.maxPercentRatio)
    : parseInt(props?.maxPercentRatio) || 100
  const {
    startIcon,
    endIcon,
    showInside = true,
    bottomText = '',
    rootClass = 'barRoot',
    valueInPercent = false,
    maxWidth,
    background = 'transparent',
    showToolTip = false,
    toolTipData,
    showLegendToolTip = false,
    showLegendToolTipData,
    customPercentage,
  } = props

  const settings = {
    width: '100%',
    maxWidth: maxWidth || 190,
    height: props?.height || '28px',
  }

  const [hoverObject, setHoverObject] = useState({})
  const tooltipRef = useRef()
  const segmentByDrivers = ['SegmentDriversAnalysis', 'DriversProgression', 'SearchDriversProgression', 'DriversProgressionWithoutSentiments', 'SegmentDriversOnlyAnalysisWithoutSentiments', 'SegmentDriversOnlyAnalysis', 'SegmentDriversOnlyAnalysis3Level']

  const getToolTipData = (id) => {
    return {
      id: id, 
      data: {
        fullLabel: "",
        id: id,
        label: "",
        otherDetails: toolTipData
      }
    }
  }

  const showToolTipFunc = (id) => {
    const data = getToolTipData(id)
    if(['Drivers', 'DriversAndSubBrands', 'DriversMotivatorsDetractors', 'DriversAndSubBrandsMotivatorsDetractors', ...segmentByDrivers].includes(data?.data?.otherDetails?.insightsElementType)){
      setHoverObject(data)
      document.querySelector(`#${id} .toolTipWrapper`).classList.add('show')
    }
  }

  const showToolTipFunc2 = (e, id) => {
    const parentId = document.querySelector(`#${id}`).getBoundingClientRect()
    const ths = document.querySelector(`#${id} .toolTipWrapper`)
    const event = e.nativeEvent

    const wt = ths.getBoundingClientRect().width
    const posi = { top: (event.clientY - parentId.top) - 30, left: 30 + event.clientX - parentId.left, class: 'tooltipPosiRight' }

    if (ths?.classList?.contains('tooltipPosiLeft')) {
      ths.classList.remove('tooltipPosiLeft')
    }
    if (ths?.classList?.contains('tooltipPosiRight')) {
      ths.classList.remove('tooltipPosiRight')
    }

    if (event.clientX > window.innerWidth - wt - 60) {
      posi.left = (event.clientX - parentId.left) - wt - 20
      posi.class = 'tooltipPosiRight'
      ths.classList.add('tooltipPosiRight')
    } else {
      posi.class = 'tooltipPosiLeft'
      ths.classList.add('tooltipPosiLeft')
    }

    ths.setAttribute('style', `top:${posi.top}px; left:${posi.left}px;`)
  }

  const hideToolTipFunc = (id) => {
    setHoverObject({})
    document.querySelector(`#${id} .toolTipWrapper`).classList.remove('show')
  }

  useEffect(() => {
    if (refBarId?.current) {
      setBarGraphWidth(refBarId.current.offsetWidth)
    }
  }, [refBarId])

  return (
    <Wrapper
      ref={refBarId}
      className={rootClass}
      sx={{
        width: settings.width,
        height: settings.height,
        // maxWidth: settings.maxWidth,
        background: background,
      }}
      showTotalAtRHS={props?.total}
    >
      {props?.data?.length > 0 && props?.data.map((L1, i) => {
        const arr = Object.keys(L1)
        let barSlicePercentageWidth = 0
        const id = `barId__${props?.toolTipData?.InsightsElementId?.replaceAll('-','') || i}__${props?.toolTipData?.levelIndexing || i}`

        return (
          <li key={i} className='barItemRoot' id={id} onMouseOver={() => showToolTipFunc(id)} onMouseMove={(event) => showToolTipFunc2(event, id)} onMouseLeave={() => hideToolTipFunc(id)}>
            <ToolTipWrapper className='toolTipWrapper' data-id={hoverObject?.id || ''}>
              {hoverObject?.id && <CustomTootTip1
                data={getToolTipData(id, i)}
                type={'toolTip1'}
                insightsElementType={hoverObject?.data?.otherDetails?.insightsElementType}
              />}
            </ToolTipWrapper>

            <Box className='barSliceWrap' sx={{ width: '100%', display: 'flex', alignItems: 'center', paddingRight: '45px' }}>
              {!!startIcon && (
                <Box className='barSliceStartIcon' sx={{ marginRight: 1 }}>
                  {startIcon}
                </Box>
              )}
              {arr.map((L2, j) => {
                const numberValue = props?.isDecimal ? parseFloat(L1[L2]) : parseInt(L1[L2])
                const widthInPercentage =
                  customPercentage && numberValue ? customPercentage : (numberValue / max) * 100
                barSlicePercentageWidth += widthInPercentage

                const l2Width = {
                  width: `${widthInPercentage}%`,
                  height: props?.height || '28px',
                  background:
                    props?.bG ||
                    props?.colorMap?.[L2] ||
                    props?.colorIndex?.[j] ||
                    LEGEND_COLOR_MAP_V2[L2] ||
                    'teal',
                  // background: props?.bG || props?.colorIndex?.[j] || LEGEND_COLOR_MAP_V2_NEW[L2] || 'teal',
                }

                const barVal =
                  showInside && L1[L2] !== 0 ? `${L1[L2]}${valueInPercent ? '%' : ''}` : null
                const toolTipBarVal = `${L1[L2]}${valueInPercent ? '%' : ''}`
                const getPxWidthFunc = () => {
                  const tdWidth = barGraphWidth - 20
                  const divPercentWidth = widthInPercentage
                  const value = (tdWidth * divPercentWidth) / 100
                  return value > 29
                }

                const toolTipDataFunc = () => {
                  let t = toolTipBarVal
                  if (!getPxWidthFunc()) {
                    t = toolTipBarVal
                    if (showLegendToolTip) {
                      t = showLegendToolTipData[j] + ' (' + t + ')'
                    }
                  } else if (showLegendToolTip) {
                    t = showLegendToolTipData[j]
                  }
                  return t
                }

                // <InnerBar data-l2={[L1[L2]]} data-max={max} data='data' className={`barSlice ${L2} ${showToolTip || ['Neutral', 'Mixed'].includes(L2) ? 'showToolTip' : null} ${!getPxWidthFunc() ? 'showToolTip' : null}`} key={j} style={l2Width} data-tool={toolTipBarVal}>

                const showToolTipClass = () => {
                  if(toolTipData) return ''
                  return `${showToolTip || ['Neutral', 'Mixed'].includes(L2) ? 'showToolTip' : ''} ${!getPxWidthFunc() ? 'showToolTip' : ''} ${showLegendToolTip ? 'showToolTip' : ''}`
                }

                return (
                  <InnerBar
                    data-l2={[L1[L2]]}
                    data-max={max}
                    data='data'
                    className={`barSlice ${L2} ${showToolTipClass()}`}
                    key={j}
                    style={l2Width}
                    data-tool={toolTipDataFunc()}
                  >
                    {showInside && getPxWidthFunc() && L1[L2] !== 0 ? (
                      <span className='barSliceLabel'>
                        {customPercentage ? parseInt(barVal).toLocaleString() : barVal}
                      </span>
                    ) : null}
                    {/* {arr.length - 1 === j && props?.total && (<span className='barSlicePercentage'>{props?.total}{valueInPercent ? '%' : ''}</span>)} */}
                  </InnerBar>
                )
              })}
              {props?.total && (
                <div className='barSlicePercentage' style={{ left: `${barSlicePercentageWidth>100 ? 100 : barSlicePercentageWidth}%` }}>
                  {props?.total}
                  {valueInPercent ? '%' : ''}
                </div>
              )}
              {/* {props?.total && (<div className='barSlicePercentage'>{props?.total}{valueInPercent ? '%' : ''}</div>)} */}

              {!!endIcon && (
                <Box className='barSliceEndIcon' sx={{ marginLeft: 1 }}>
                  {endIcon}
                </Box>
              )}
            </Box>
            {!!bottomText && (
              <Box
                className='barSliceBottom'
                sx={{ marginTop: '2px', fontSize: '14px', fontWeight: 300, whiteSpace: 'nowrap' }}
              >
                {bottomText}
              </Box>
            )}
          </li>
        )
      })}
    </Wrapper>
  )
}
